<template>
  <div>
    <h3>帖子管理</h3>
    <el-table :data="tableData" border>
      <el-table-column prop="id" label="帖子ID"/>
      <el-table-column prop="userId" label="用户ID"/>
      <el-table-column prop="title" label="标题"/>
      <el-table-column prop="content" label="内容"/>
      <el-table-column prop="createdAt" label="发布时间"/>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="danger" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {getPostList,delPost} from "../api";
export default {
  data(){return {tableData:[]}},
  mounted(){this.load()},
  methods:{
    async load(){
      const res = await getPostList()
      this.tableData = res.data.list
    },
    async handleDel(id){
      await delPost(id)
      this.$message.success('删除成功')
      this.load()
    }
  }
}
</script>
